import { GET_ROTATE_POSITIONS, GET_ROTATE_POSITIONS_SUCCESS, GET_ROTATE_POSITIONS_ERROR } from './actionTypes';

export const getRotatePositions = (user, history) => {
  return {
    type: GET_ROTATE_POSITIONS,
    payload: { user, history },
  };
};

export const getRotatePositionsSuccess = (message, rotate_positions) => {
  return {
    type: GET_ROTATE_POSITIONS_SUCCESS,
    payload: { message, rotate_positions },
  };
};

export const getRotatePositionsError = (message) => {
  return {
    type: GET_ROTATE_POSITIONS_ERROR,
    payload: message,
  };
};
